import { render, staticRenderFns } from "./DownloadAgents.vue?vue&type=template&id=218ebf54"
import script from "./DownloadAgents.vue?vue&type=script&lang=js"
export * from "./DownloadAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports